
import Vue from 'vue';
import axios from 'axios';
import _ from 'lodash';
import { dateFormat } from '@/helpers/dateFormat';
import { ApiMigrationService } from '@/services/ApiMigrationService';

export default Vue.extend({
  props: {
    input: { type: Object, default: () => {} },
    data: { type: Object, default: () => {} },
    getVariable: { type: Function, default: () => () => {} },
    parent: { type: Object, default: () => {} }
  },
  data(): { 
    dialog: boolean,
    editFlag: number,
    defaultMessage: string,
    newComment: string,
    showMenu: boolean,
    searchResults: any[],
    loading: boolean
  } {
    return {
      dialog: false,
      editFlag: 0,
      defaultMessage: '',
      newComment: '',
      showMenu: false,
      searchResults: [],
      loading: false
    };
  },
  computed: {
    chatMessages: function(): any[] {
      return this.getVariable(this.input.commentsVariable);
    }
  },
  watch: {
    newComment() {
      if(this.newComment) {
        const { prefix, key } = this.parent._getPrefixAndKey(this.input.newCommentVariable);
        const parentVariable = this.parent._getVariable(prefix);
        if(!parentVariable) {
          const { prefix: parentPrefix, key: parentKey } = this.parent._getPrefixAndKey(prefix);
          this.$set(this.parent._getVariable(parentPrefix), parentKey, {});
        }
        this.$set(this.parent._getVariable(prefix), key, this.newComment);
        const lastString: string = this.newComment.replace(/\n/g,'\n ').split(' ').pop() || '';
        if(lastString.match(/^@[a-zA-Z.0-9]+$/g)) {
          this.searchEmails(lastString.slice(1));
          this.showMenu = true;
        } else {
          if(this.showMenu) this.showMenu = false;
        }
      }
    }
  },
  methods: {
    transformComment: function(message: string) {
      let result =  message.replace(/@([a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z]{2,6})/g, (match, p1) => {
        return `<span class="blue--text">@${p1}</span>`;
      });
      result = result.replace(/https?:\/\/[^\s]+/g, (match) => {
        return `<a href="${match}" target="__blank">${match}</a>`;
      });
      return result;
    },
    submitComment: function() {
      this.parent._callMultipleFunctions(this.input.addComentAction);
      this.newComment = '';
    },
    deleteComment: function(message: any) {
      this.parent._callMultipleFunctions(this.input.deleteCommentAction, message);
    },
    enableEdit: function(message: any) {
      if(this.editFlag) this.revertEdit(this.editFlag);
      this.editFlag = message._id;
      this.defaultMessage = message.text;
    },
    disableEdit: function(messageId: number) {
      this.revertEdit(messageId);
      this.editFlag = 0;
      
    },
    revertEdit: function(messageId: number) {
      const chatMessages: any[] = this.getVariable(this.input.commentsVariable);
      const selectedMessage = chatMessages.find((message: any) => message._id == messageId);
      selectedMessage.text = this.defaultMessage;
    },
    updateComment: function(message: any) {
      this.parent._callMultipleFunctions(this.input.updateCommentAction, message);
      this.editFlag = 0;
      this.defaultMessage = '';
    },
    searchEmails: async function(searchString: string) {
      try {
        this.loading = true;
        const originalUrl = `/api/v1/users/search-emails?pattern=${searchString}`;
        const { resolvedUrl, transformResponse } = ApiMigrationService.getRoutedApi(originalUrl, null);
        const response = await axios.get(resolvedUrl);
        let responseData = response.data;
        if (transformResponse) {
          responseData = transformResponse(responseData);
        }
        this.searchResults = _.get({ data: responseData }, 'data.data.users', []);
        this.loading = false;
      } catch (error) {
        this.loading = false;
      }
    },
    clickUser(email: string) {
      this.loading = false;
      const commentStringArray: string[] = this.newComment.replace(/\n/g,'\n ').split(' ') || [];
      commentStringArray.pop();
      this.newComment = `${commentStringArray.join(' ')} @${email}`;
      this.showMenu = false;
    },
    formatDate(date: string): string {
      return dateFormat(date, 'show-time');
    }
  }
})
